<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NPeevk/tc-custom/9798889101611.jpg?1718106101436" alt="This image is the cover for the book You Are Beautiful"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">You Are Beautiful
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Aptos",sans-serif;text-align:center;'><em><span style='font-size:16px;font-family:"Times New Roman",serif;'>You Are Beautiful</span></em><span style='font-size:16px;font-family:"Times New Roman",serif;'> is a contemporary children’s book that celebrates children’s differences. </span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Aptos",sans-serif;text-align:center;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>This is a book that any child can pick up to read and feeling good about themselves and their friends.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Aptos",sans-serif;text-align:center;'><em><span style='font-size:16px;font-family:"Times New Roman",serif;'>You Are Beautiful</span></em><span style='font-size:16px;font-family:"Times New Roman",serif;'> is a representation of many children, including those with special needs. </span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Aptos",sans-serif;text-align:center;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>This book highlights differences, teaches kindness, understanding and reminds us all that we are beautiful just the way we are.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ashley E. Kettering
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'><span style="font-size:15px;">Ashley E. Kettering currently resides in Illinois but was born and raised in Sheboygan, Wisconsin. She is married and has a beautiful daughter and twin boys. She loves animals and has two dogs and a sassy cat. She is a high school English teacher. She graduated with honors from the University of Wisconsin-Oshkosh. She and her family enjoy traveling, swimming, and trying different foods. Mrs. Kettering is an avid reader and enjoys spending her summers at Elkhart Lake with her family and friends.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43cea046